import axios from "axios";

export default axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json"
  },
});

export const axiosPrivate = axios.create({
  baseURL: import.meta.env.VITE_PRIVATE_API_URL,
  headers: {
    "Content-Type": "application/json"
  },
});
